module.exports = __webpack_public_path__ + "friend-referral-white.svg?2d6f514ceaeea7afc990b98231889725";